import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import loaninaction from "../../context/action/customer/loaninaction";
import { useReactToPrint } from "react-to-print";
import { Loanbackprint } from "./loanbackprint";

const Loanbackmodal = (props) => {
    const { initState, recaller, setrecaller, clear, initDispatch } =
        useContext(GlobalContext);
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    const [loan_in_id, setloan_in_id] = useState();
    const [loan_in_date, setloan_in_date] = useState(today);
    const [amount, setamount] = useState();
    const [dollar_price, setdollar_price] = useState(initState?.dollar_price);
    const [note, setnote] = useState();
    const [loan_loading, setloan_loading] = useState(false);
    const [error, seterror] = useState(false);
    const [error1, seterror1] = useState(false);

    const printRef = useRef();
    
    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: "loanback",
        preserveAfterPrint: true,
        print: (printIframe) =>
        new Promise(() => {
            printIframe.style.display = "none";
            printIframe.contentWindow?.print();
        }),
    });
    return (
        <>
            {props.show ? (
            <>
                <div
                    style={{
                    position: 'absolute',
                    left: '-99999px',
                    top: 0
                    }}
                >
                    <Loanbackprint ref={printRef} dollar_price={dollar_price} loan_in_id={loan_in_id} loan_in_date={loan_in_date} amount={amount} note={note} customer_id={props?.customer_id} customer_name={props?.customer_name} customer_address={props?.customer_address} customer_phone={props?.customer_phone} customer_loan={props?.customer_loan} />
                </div>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
                <div className="relative w-full max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-3xl xl:max-w-4xl mx-auto my-6">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-center justify-between p-4 sm:p-5 border-b border-solid border-slate-200 rounded-t">
                        <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                            گێڕانەوەی قەرز
                        </h3>
                        <button
                            className="p-1 ml-2 bg-transparent border-0 text-black opacity-80 text-2xl sm:text-3xl leading-none font-semibold outline-none focus:outline-none hover:opacity-100 transition-opacity"
                            onClick={() => props.setshow(false)}
                        >
                            <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                                X
                            </span>
                        </button>
                    </div>
                    {/*body*/}
                    <div className="relative p-4 sm:p-6 flex-auto">
                        <div className="grid grid-cols-1 gap-4">
                        <div className="w-full">
                            <label
                            className={
                                error
                                ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                                : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            }
                            htmlFor="amount"
                            >
                            بڕی پارە
                            </label>
                            <input
                            className={
                                error
                                ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            }
                            id="amount"
                            type="number"
                            placeholder=""
                            onClick={(val)=>{val.target.select()}}
                            value={amount}
                            onChange={(val) => setamount(val.target.value)}
                            onFocus={() => seterror(false)}
                            />
                        </div>
                        <div className="w-full">
                            <label
                            className={
                                error1
                                ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                                : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            }
                            htmlFor="dollar_price"
                            >
                            نرخی دۆلار
                            </label>
                            <input
                            className={
                                error1
                                ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            }
                            id="dollar_price"
                            type="number"
                            placeholder=""
                            onClick={(val)=>{val.target.select()}}
                            value={dollar_price}
                            onChange={(val) => setdollar_price(val.target.value)}
                            onFocus={() => seterror1(false)}
                            />
                        </div>
                        <div className="w-full">
                            <label
                            className={
                                "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                            }
                            htmlFor="note"
                            >
                            تێبینی
                            </label>
                            <input
                            className={
                                "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            }
                            id="note"
                            type="text"
                            placeholder=""
                            onClick={(val)=>{val.target.select()}}
                            value={note}
                            onChange={(val) => setnote(val.target.value)}
                            />
                        </div>
                        </div>
                    </div>
                    {/*footer*/}
                    <div className="flex flex-col sm:flex-row items-center justify-end gap-3 p-4 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                        <button
                        className="w-full sm:w-auto bg-white text-red-500 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded outline-none focus:outline-none ease-linear transition-all duration-150 order-2 sm:order-1"
                        type="button"
                        onClick={() => {
                            props.setshow(false);
                        }}
                        >
                        داخستن
                        </button>
                        <button
                        className={loan_loading?"w-full sm:w-auto bg-emerald-300 text-white font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-1 sm:order-2":
                            "w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-1 sm:order-2"}
                        disabled={loan_loading}
                        type="button"
                        onClick={() => {
                            if (amount < 1) {
                                seterror(true);
                                return false;
                            }
                            if (dollar_price < 1) {
                                seterror1(true);
                                return false;
                            }
                            setloan_loading(true);
                            loaninaction(props.customer_id,amount, dollar_price,note,initState.token.user_id)(recaller)(setrecaller)(initDispatch)(clear)(setloan_in_id)(printFn)(setloan_loading);
                        }}
                        >
                        {loan_loading?<div className="flex items-center justify-center space-x-2">
                            <svg
                              className="animate-spin h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                              ></circle>
                              <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                              ></path>
                            </svg>
                        </div>:"ناردن"}
                        </button>
                    </div>
                    </div>
                </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
            ) : null}
        </>
    )
}

export default Loanbackmodal